module.exports = __webpack_public_path__ + "img/que.29efdb03.png";